export default [
  {
    text: 'Центральное',
    value: 'central',
  },
  {
    text: 'Автономное',
    value: 'autonomous',
  },
];
